
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'oxd-branding',

  props: {
    url: {
      type: String,
      default: '/',
    },
    logoSrc: {
      type: String,
      default: '',
    },
    bannerSrc: {
      type: String,
      default: '',
    },
    toggle: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes(): object {
      return {
        toggled: this.toggle,
      };
    },
  },
});
